(function() {
    'use strict';
    angular
        .module('emarket.main.plan')
        .controller('PlanController', ['SaleProducts', 'Profile', 'Auth', function(SaleProducts, Profile, Auth) {
            var vm = this;
            var user = Auth.getUser();
            SaleProducts.$search({
                type: 'plan',
                $sort: {
                    price: 1
                }
            })
                .$asPromise()
                .then(function(response) {
                    var freePlan = response.filter(function(plan) {
                        return plan.price === 0;
                    })[0];
                    var plans = response
                        .sort(function(plana, planb) {
                            return plana.price - planb.price;
                        })
                        .filter(function(plan) {
                            return plan.price > 0;
                        });
                    vm.plans = plans;
                    vm.freePlan = freePlan;
                });
            vm.buy = function(plan) {
                Profile.showBuyPlanDialog(vm.plans, plan);
            };
        }]);
}());
